import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatViews } from "@/utils/format";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link to={`/detail/${movie.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title}封面`}
          title={`${movie.title} 影视详情 剧情与演员信息`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

        <div className="absolute left-2 top-2 flex items-center gap-1">
          <span className="rounded-sm bg-primary-950/80 px-1.5 py-0.5 text-[10px] font-medium text-background-50 backdrop-blur-sm">
            {movie.type}
          </span>
        </div>

        <div className="absolute right-2 top-2 flex items-center gap-1 rounded-sm bg-accent-500 px-1.5 py-0.5">
          <i className="ri-star-fill text-[10px] leading-none text-primary-950" />
          <span className="font-label text-[11px] font-semibold leading-none text-primary-950">{movie.rating.toFixed(1)}</span>
        </div>

        {typeof rank === "number" && (
          <div className="absolute bottom-2 left-2 flex h-8 w-8 items-center justify-center rounded-md bg-primary-950/85 backdrop-blur-sm">
            <span className="font-label text-sm font-bold text-accent-400">{String(rank).padStart(2, "0")}</span>
          </div>
        )}

        <div className="absolute inset-x-2 bottom-2 translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex items-center justify-center gap-1 rounded-md bg-background-50/95 py-1.5 text-[11px] font-medium text-primary-950">
            查看详情
            <i className="ri-arrow-right-line text-xs w-3.5 h-3.5 flex items-center justify-center" />
          </span>
        </div>
      </div>

      <h3 className="mt-3 truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600">
        {movie.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(" / ")}
      </p>
      <p className="mt-0.5 truncate text-xs text-foreground-500">播放 {formatViews(movie.views)}</p>
    </Link>
  );
}